<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sub-Module Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form
              v-if="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh' ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getAllSubModuleMasterList('Excel')" size="sm" variant="outline-info">{{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>

            </b-nav-form>

          </b-navbar-nav>

          <!-- <b-button
            v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
            size="sm"
            class="ml-1"
            @click="getReports('All_Module_Report')"
            variant="outline-info"
          >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="justify-content-left">
                <b-col md="12">
                  <h5>{{SubModuleMaster.submodule_name}} Sub-Module Details</h5>
                </b-col>
                <b-col md="3">
                  <label>
                    Module Name
                    <span class="error">*</span>
                  </label>
                  <model-list-select :list="All_Module_List" v-model="SubModuleMaster.fk_module_id"
                    option-value="module_id" option-text="module_name"
                    placeholder="Select Module Name"></model-list-select>
                  <span class="error" v-if="!SubModuleMaster.fk_module_id">
                    {{
                    errorList.fk_module_id
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Sub-Module Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="submodule_name" name="submodule_name"
                    v-model="SubModuleMaster.submodule_name" placeholder="Sub Module Name"
                    @input="submoduleUrl(SubModuleMaster.submodule_name)"></b-form-input>
                  <span class="error" v-if="!SubModuleMaster.submodule_name">
                    {{
                    errorList.submodule_name
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Sub-Module URL <span class="error">*</span></label>
                  <b-form-input id="submodule_url" name="submodule_url" v-model="SubModuleMaster.submodule_url"
                    placeholder="Sub-Module URL"></b-form-input>

                  <!-- <span class="error" v-if="!SubModuleMaster.submodule_url">
                    {{
                    errorList.submodule_url
                    }}
                  </span> -->
                </b-col>

                <b-col md="3">
                  <label>Status</label><br>
                  <md-switch :id="'approval'+SubModuleMaster.is_submodule_active" name="approval" class="md-primary"
                    :value="SubModuleMaster.is_submodule_active==1?true:false" @change="activatesubmoduleMaster()">
                    <h6>
                      <b-badge
                        :variant="SubModuleMaster.is_submodule_active==1?'success':'danger'">{{SubModuleMaster.is_submodule_active==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addSubModuleMaster" class="mt-2"
                      id="addButtonLoader">
                      {{
                      submoduleMaster.submodule_id ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Sub-Module Master" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Sub_Module_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="submodule_id" class="position-relative">
                  <template slot="submodule_id" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="module_name" slot-scope="row5">
                    <span>{{row5.item.module_name }}</span>
                  </template>
                  <template slot="submodule_name" slot-scope="row1">
                    <span
                      @click="$sessionsStorage.get('designation') == 'Admin' &&  $sessionsStorage.get('nameUser') == 'Bhavneesh'? viewEdit(row1.item):''"
                      class="showMoreData">{{row1.item.submodule_name}}</span>
                  </template>
                  <template slot="submodule_url" slot-scope="row11">
                    <span>{{(row11.item.submodule_url!='')?row11.item.submodule_url:'--'}}</span>
                  </template>
                  <template slot="is_submodule_active" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.submodule_id">
                      <md-switch :id="'approval'+row22.item.submodule_id" name="approval" class="md-primary"
                        :value="row22.item.is_submodule_active==1?true:false"
                        @change="activateModuleUser(row22.item, 'Active')">
                        <h6>
                          <br>
                          <b-badge
                            style="margin-left:-45px">{{row22.item.is_submodule_active==1?'Active':'In-Active'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.submodule_id">
                      <h6>
                        <b-badge>{{row22.item.is_submodule_active==1?'Active':'In-Active'}}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="is_submodule_delete" slot-scope="row22">
                    <div v-if="adminToggle =='Admin'" :id="'row'+row22.item.submodule_id">
                      <md-switch :id="'approval'+row22.item.submodule_id" name="approval" class="md-primary"
                        :value="row22.item.is_submodule_delete==1?true:false"
                        @change="activateModuleUser(row22.item, 'Delete')">
                        <h6>
                          <br>
                          <b-badge style="margin-left:-45px">{{row22.item.is_submodule_delete==1?'Delete':'Not Deleted'}}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row'+row22.item.submodule_id">
                      <h6>
                        <b-badge>{{row22.item.is_submodule_delete==1?'Deleted':'Not Delete'}}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editSubModuleMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/submoduleMaster");
      if (globalPermissionStatus("Sub-Module Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Sub-Module Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getAllSubModuleMasterList('Normal');
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
    this.$store.dispatch(
      "common/setAllModuleList",
      JSON.stringify({
        itemCode: "ModuleList",
      })
    );
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "submodule_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "module_name",
          label: "Module Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "submodule_name",
          label: "Sub-Module Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "submodule_url",
          label: "Sub-Module URL",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_submodule_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_submodule_delete",
          label: "Is Delete",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "action",
          sortable: true,
          sortDirection: "desc"
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      SubModuleMaster: {
        submodule_id: "",
        fk_module_id: "",
        module_name: "",
        submodule_name: "",
        submodule_url: "",
        is_submodule_active: true,
        TypeofAdd: "Sub-Sub-Module Master Add"
      },
      SubModuleMasterError: [
        "Please Select Module Name",
        "Please Enter Sub-Module Name",
        "Please Enter Sub-Module URL",
      ],
      errorList: {
        fk_module_id: "",
        submodule_name: "",
        submodule_url: "",
      },
      All_Sub_Module_List_data: [],
      All_Module_List: [],
      validate: true
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    activatesubmoduleMaster() {
      if (this.submoduleMaster.is_submodule_active == 1 || this.submoduleMaster.is_submodule_active == true) {
        this.submoduleMaster.is_submodule_active = false;
      } else if (
        this.submoduleMaster.is_submodule_active == 0 ||
        this.submoduleMaster.is_submodule_active == false
      ) {
        this.submoduleMaster.is_submodule_active = true;
      }
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.submoduleMaster.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    activateModuleUser(item, type) {
      let FieldVal = '';
      let TableField = '';
      if(type == "Active"){
        FieldVal = item.is_submodule_active == 1 ? 0 : 1;
        TableField = "is_submodule_active";
      } else if(type == "Delete"){
        FieldVal = item.is_submodule_delete == 1 ? 0 : 1;
        TableField = "is_submodule_delete";
      }
      let payload = {
          tableName: "submodule_master",
          tableId: "submodule_id",
          tableIsActive: TableField,
          value1: FieldVal,
          tableVal: item.submodule_id,
          isMailSend:'No',
          manual:'No',
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
      .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getAllSubModuleMasterList("Normal");
          }
      })
      .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
      });
    },


    validateSubModuleMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
          if (
          this.SubModuleMaster[x] == "" ||
          this.SubModuleMaster[x] == undefined ||
          this.SubModuleMaster[x] == null
          ) {
              console.log("this.SubModuleMaster[x]=>",this.SubModuleMaster[x],x);
              console.log("this.SubModuleMaster[x]=>",this.SubModuleMaster);
          this.errorList[x] = this.SubModuleMasterError[index];
          validate_new = false;
          }
      });
      if (validate_new != true) {
          this.validate = false;
          return;
      } else {
          this.validate = true;
      }
    },
    addSubModuleMaster() {
      this.validateSubModuleMaster();
      this.SubModuleMaster.TypeofAdd = "Sub-Module Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
          itemCode: "add_Sub_Module_Details",
          SubModuleMaster: this.SubModuleMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
          CommonService.getAllCommonMaster(payload)
          .then(response => {
              const { data, status, statusText } = response;
              if (data.submodule_id != "" && data.submodule_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                } else {
                    this.alert.content = data.MSG;
                }
                this.addEditCardFunc();
                this.getAllSubModuleMasterList('Normal');
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
          })
          .catch(error => {
              console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    clearErrVal() {
      this.submoduleMaster = {
        submodule_id: "",
        fk_module_id: "",
        module_name: "",
        submodule_name: "",
        submodule_url: "",
        is_submodule_active: true,
        TypeofAdd: "Sub-Module Master Add"
      };
    },
    getAllSubModuleMasterList(type) {
      this.All_Sub_Module_List_data = [];
      this.totalRows = 0;
      this.isLoading = true;
      if(type == "Excel"){
        this.ExcelBtnName = "Downloading Please Wait...";
      }
      let payload = {
          itemCode: "All_Sub_Module_List",
          Filter: this.filter,
          type: type,
      };
      // JSON.stringify();
      // await
      CommonService.getAllCommonMaster(payload)
      .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.All_Sub_Module_List_data.length > 0) {
                this.All_Sub_Module_List_data = data.All_Sub_Module_List_data;
                this.totalRows = data.All_Sub_Module_List_data.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.All_Sub_Module_List_data.length > 0) {
                this.All_Sub_Module_List_data = data.All_Sub_Module_List_data;
                this.totalRows = data.All_Sub_Module_List_data.length;
                console.log(" All_Sub_Module_List response=>", data);
              }
            }
          } else {
            this.All_Sub_Module_List_data = [];
          }
          this.isLoading = false;
      })
      .catch(error => {
          console.log("Catch on All_Sub_Module_List Error: ", error);
      });
    },
    
    editSubModuleMaster(item) {
      console.log(item);
      this.clearErrVal();
      this.addEditCard = true;
      this.All_Module_List = this.$store.getters["common/getAllModuleList"];
      item.TypeofAdd = "Sub-Module Master Add";
      this.SubModuleMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
      this.All_Module_List = this.$store.getters["common/getAllModuleList"];
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllSubModuleMasterList('Normal');
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllSubModuleMasterList('Normal');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    submoduleUrl(item) {

      const submoduleName = item.toLowerCase().replaceAll(' ',"_");
      console.log('modulename => ', submoduleName);
      this.SubModuleMaster.submodule_url = submoduleName; 
    },
      
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// submoduleMaster.vue?4d9b04a2